import { useEffect } from 'react';

const RedirectToMainSite = () => {
  useEffect(() => {
    // Okamžité a "tvrdé" přesměrování na hlavní firemní web
    // Používáme replace, aby se tato "chybová" stránka neuložila do historie prohlížeče
    window.location.replace("https://www.elektromotory.cz");
  }, []);

  // Vrátíme null, protože se komponenta nikdy reálně nezobrazí,
  // jen vykoná přesměrování.
  return null;
};

export default RedirectToMainSite;